import { add, money, scale, toDb } from '@miraki/money';
import type { OrderDetail } from '../../api/types';

type Line = OrderDetail['lines'][number];
export interface Draft { quantity: string; size: string }

/** What the form says, as the changes it would make against the order as it stands. */
export function draftChanges(lines: readonly Line[], drafts: Record<string, Draft>) {
  const out: Array<{ line: Line; quantity: number; size: string | null }> = [];
  for (const l of lines) {
    const d = drafts[l.id];
    if (!d) continue;
    const quantity = Number(d.quantity);
    const size = d.size.trim() === '' ? null : d.size.trim();
    if (!Number.isInteger(quantity) || quantity < 1) continue;
    if (quantity !== l.quantity || size !== (l.size ?? null)) out.push({ line: l, quantity, size });
  }
  return out;
}

/** True when any quantity typed is not a whole number of at least one. */
export const hasBadQuantity = (lines: readonly Line[], drafts: Record<string, Draft>) =>
  lines.some((l) => {
    const q = drafts[l.id]?.quantity;
    return q !== undefined && (!/^\d+$/.test(q.trim()) || Number(q) < 1 || Number(q) > 100000);
  });

/** The order's total if every typed quantity were applied, by the agreed unit prices (decimal strings, never numbers). */
export function totalWith(lines: readonly Line[], drafts: Record<string, Draft>): string {
  let total = money('0');
  for (const l of lines) {
    const q = Number(drafts[l.id]?.quantity ?? l.quantity);
    total = add(total, scale(money(l.agreedUnitPrice), Number.isInteger(q) && q >= 1 ? q : l.quantity));
  }
  return toDb(total);
}

